<template>
  <div>
    <section class="round_ended">
      <div class="round_ended__head">
        <div class="round_ended__head__top">
          <h1>{{ isGameWinner ? getTranslations.home_modals_post_you_won_the_game : getTranslations.home_modals_post_you_lost_the_game }}</h1>
        </div>
        <div class="round_ended__head__bottom">
          <div :class="['round_ended__head__bottom__player round_ended__head__bottom__player--p1 ', isHomePlayer?(isGameWinner ? 'winner':'lost') : isGameWinner ?  'lost':'winner']">
            <img :src="playersDetails.homePlayerAvatar" alt="">
            <span>{{ playersDetails.homePlayerUsername }}</span>
            <ul class="player_score player_score left_player">
              <li v-for="(item, index) in numberOfQuestionsPerRound" :key="index" :class="getHomePlayerAnswersHistory(index)"></li>
            </ul>
          </div>
          <div :class="['round_ended__head__bottom__player round_ended__head__bottom__player--p2 ', isHomePlayer?(isGameWinner ? 'lost':'winner') : isGameWinner ? 'winner':'lost']">
            <img :src="playersDetails.awayPlayerAvatar" alt="">
            <span>{{ playersDetails.awayPlayerUsername }}</span>
            <ul class="player_score player_score right_player">
              <li v-for="(item, index) in numberOfQuestionsPerRound" :key="index" :class="getAwayPlayerAnswersHistory(index)"></li>
            </ul>
          </div>
        </div>
      </div>
      <div :class="['round_ended__center-score  ', isGameWinner ? 'winner':'lost']">
        <p><span >{{ homePlayerRoundScore }}</span>-<span>{{ awayPlayerRoundScore }}</span> </p>
      </div>
      <div class="round_ended__bottom">
        <h2 v-if="isEqualAmountOfCorrectAnswers && isGameWinner">{{ getTranslations.home_round_ended_you_were_faster }}</h2>
        <h2 v-if="isEqualAmountOfCorrectAnswers && !isGameWinner">{{ getTranslations.home_round_ended_you_were_slower }}</h2>
        <div v-if="isEqualAmountOfCorrectAnswers" class="donut-chart donut-chart--speed">
          <div class="games-left donut-chart__info">{{ homePlayerTotalAnswerTimeInSec }} ''</div>
          <div id="level_chart" class="donut-size donut-cont">
            <div class="pie-wrapper">
              <span class="label">
                <span class="smaller">{{ getTranslations.home_round_ended_answer_speed }}</span>
              </span>
              <div class="pie">
                <div class="left-side half-circle"></div>
                <div class="right-side half-circle"></div>
              </div>
              <div class="shadow"></div>
            </div>
          </div>
          <div class="games-played donut-chart__info">{{ awayPlayerTotalAnswerTimeInSec }} ''</div>
        </div>
      </div>
      <component :is="currentModal" v-on:updateNormalTransitionAndStartNewGame="updateNormalTransitionAndStartNewGame"></component>
    </section>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { Howl } from 'howler';
import { pieChartAnimation } from '@/common/jQuery';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import PostGame from '@/components/home/modals/PostGame';
import SpinWheel from '@/components/home/modals/SpinWheel';
import LevelUp from '@/components/home/modals/LevelUp';

export default {
  name: 'round-ended',
  mixins: [ParseResponseMixin, GameMixin2],
  data() {
    return {
      showedSpinModal: false,
      stompClient: null,
      subscription: null,
      currentModal: null,
      showedModal: false,
      userLevel: 0,
      bonusPoints: 0,
      gamesEarned: 0,
      gameWonSound: new Howl({
        src: ['static/sounds/GameWin.ogg', 'static/sounds/GameWin.mp3'],
      }),
      gameLostSound: new Howl({
        src: ['static/sounds/LoseGame.ogg', 'static/sounds/LoseGame.mp3'],
      }),
    };
  },
  mounted() {
    console.log('in RoundEnded mounted hook:');
    console.log(`isGameWinner: ${this.isGameWinner}`);
    if (this.isEqualAmountOfCorrectAnswers) {
      setTimeout(() => {
        pieChartAnimation('#level_chart', this.getAnswerTimeRatio());
      }, 350);
    }
    setTimeout(() => {
      if (this.gameFinished) {
        // wait 5 secs and show post game modal
        this.currentModal = PostGame;
        console.log('showing post game modal...');
        this.showHideModal();
      } else {
        console.log('In regular Duel projects select Theme Page will be displayed...');
      }
    }, 5000);
  },
  beforeDestroy() {
    this.initNextRoundData();
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'increaseCurrentRoundNumberbyOne',
      'setCurrentQuestionNumber',
      'resetPlayersAnswersHistoryCSSClasses',
    ]),
    ...mapMutations('profile', [
      'setShowmodalForLevelUp',
      'setNotificationRewardId',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
    ]),
    initNextRoundData() {
      console.log('initializing data for next round');
      this.setCurrentQuestionNumber(0);
      this.resetPlayersAnswersHistoryCSSClasses();
    },
    showHideModal() {
      this.$nextTick(() => {
        // eslint-disable-next-line
        $('.modal,.modal-overlay').fadeIn(200);
        if (this.soundsOn) {
          if (this.isGameWinner) {
            this.gameWonSound.play();
          } else {
            this.gameLostSound.play();
          }
        }
        /* eslint-disable */
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          console.log('RoundEnded' + this.userLeveledUp + this.showedModal);
          /* eslint-enable */
          if (this.userLeveledUp && !this.showedModal) {
            const notificationLevelupData = {
              userLevel: this.isHomePlayer ? this.homePlayerLevel : this.awayPlayerLevel,
              bonusPoints: this.isHomePlayer ? this.homePlayerLevelUpBonusPoints : this.awayPlayerLevelUpBonusPoints,
              gamesEarned: this.isHomePlayer ? this.homePlayerGamesEarned : this.awayPlayerGamesEarned,
            };
            console.log(`We have a special Notification ${notificationLevelupData}`);
            console.log(`We have a special Notification type with DATA: ${notificationLevelupData.userLevel}`);
            this.setShowmodalForLevelUp({ notificationLevelupObject: notificationLevelupData });
            this.getUserLoginDetails().then(() => {
              this.currentModal = LevelUp;
              this.showedModal = true;
              console.log('showing level up pop up');
              this.showHideModal();
            });
          } else if (this.spinWheelInfo.showSpinWheel && !this.showedSpinModal) {
            this.setNotificationRewardId({ value: this.spinWheelInfo.correlationId });
            this.setNotificationRewardName({ value: this.spinWheelInfo.prizeName });
            this.setNotificationPrizeWon({ value: this.spinWheelInfo.hasWon });
            this.currentModal = SpinWheel;
            this.showedSpinModal = true;
            this.showHideModal();
          } else {
            console.log('user has not leveled up, going to home page');
            this.currentModal = null;
            if (this.getUserAvailableGames === 0) {
              sessionStorage.removeItem('zeroBalancePopUp');
            }
            this.getUserLoginDetails().then(() => {
              this.$router.push('/home');
            });
          }
        });
      });
    },
    getHomePlayerAnswersHistory(answerIndex) {
      const homePlayerAnswersHistory = this.homePlayerCorrectAnswersCSSClasses[answerIndex];
      return homePlayerAnswersHistory !== undefined ? homePlayerAnswersHistory : '';
    },
    getAwayPlayerAnswersHistory(answerIndex) {
      const awayPlayerAnswersHistory = this.awayPlayerCorrectAnswersCSSClasses[answerIndex];
      return awayPlayerAnswersHistory !== undefined ? awayPlayerAnswersHistory : '';
    },
    getAnswerTimeRatio() {
      return (this.awayPlayerRoundAnswerTime / (this.homePlayerRoundAnswerTime + this.awayPlayerRoundAnswerTime)) * 100;
    },
    updateNormalTransitionAndStartNewGame() {
      console.log('New Game button of post game pop up clicked');
      this.normalTransition = true;
      this.$router.push('/searchingOpponent');
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'soundsOn',
    ]),
    ...mapState('game', [
      'spinWheelInfo',
      'numberOfQuestionsPerRound',
      'homePlayerLevel',
      'awayPlayerLevel',
      'playersDetails',
      'currentRoundNumber',
      'homePlayerRoundScore',
      'awayPlayerRoundScore',
      'gameFinished',
      'userLeveledUp',
      'homePlayerCorrectAnswersCSSClasses',
      'homePlayerRoundAnswerTime',
      'awayPlayerCorrectAnswersCSSClasses',
      'awayPlayerRoundAnswerTime',
      'awayPlayerGamesWon',
      'awayPlayerLevelUpBonusPoints',
      'homePlayerLevelUpBonusPoints',
      'homePlayerGamesWon',
      'homePlayerGamesEarned',
      'awayPlayerGamesEarned',
    ]),
    ...mapGetters('game', [
      'isEqualAmountOfCorrectAnswers',
      'isHomePlayer',
      'isGameWinner',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getUserAvailableGames',
    ]),
    homePlayerTotalAnswerTimeInSec() {
      return (this.homePlayerRoundAnswerTime / 1000.0).toFixed(1);
    },
    awayPlayerTotalAnswerTimeInSec() {
      return (this.awayPlayerRoundAnswerTime / 1000.0).toFixed(1);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/RoundEnded.vue